import React from "react";
import { Box } from "@mui/material";

const construction = "../../images/extra/construction.png";

const ComingSoon = ({ backgroundColor = "black", color = "white" }) => {
  return (
    <Box
      sx={{
        height: "100vh",
        display: "grid",
        backgroundColor: backgroundColor,
        color: color,
        placeItems: "center",
      }}
    >
      <img alt="Under Construction" height={150} src={construction} />
    </Box>
  );
};

export default ComingSoon;
